<div class="ui attached segment" appMargin marginT="5">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <div fxFlex="20%">
      {{ log?.requestPath | truncate: 30 }}
    </div>
    <div fxFlex="15%">
      {{ log?.requestMethod }}
    </div>
    <div fxFlex="15%">
      {{ log?.dateRequested | date: "dd MMM, yyyy, h:mm a" }}
    </div>
    <div fxFlex="15%">
      {{ log?.ipAddress }}
    </div>
    <div fxFlex="10%">
      {{ log?.responseStatusCode }}
    </div>
    <div fxFlex="15%">
      {{ log?.responseTime }}
    </div>
    <div fxFlex="10%">
      <sui-checkbox
        [(ngModel)]="isIpBlackListed"
        (click)="blackListToogleButtonClick()"
        class="toggle enable_on_save"
      >
      </sui-checkbox>
    </div>
  </div>
</div>
